const ShPaymentFriendlyName = ( { paymentMethod } ) => {

    if (paymentMethod === "creditcard") {
        return "Kreditkarte";
    } else if (paymentMethod === "paypal") {
        return "PayPal";
    } else if (paymentMethod === "sepa") {
        return "SEPA"
    } else {
        return paymentMethod;
    }

};

export default ShPaymentFriendlyName;
